import { render, staticRenderFns } from "./ProdEpiOut.vue?vue&type=template&id=2fc097ea&scoped=true&"
import script from "./ProdEpiOut.vue?vue&type=script&lang=js&"
export * from "./ProdEpiOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc097ea",
  null
  
)

export default component.exports